import { Components, Theme } from "@mui/material"

export const MuiTab: Required<Components<Theme>>["MuiTab"] = {
  styleOverrides: {
    root: ({
      theme: {
        palette,
        uisk: { spacing },
        typography,
      },
    }) => ({
      ...typography["Text md/Regular"],
      padding: spacing.sm,
      border: "none",
      minHeight: "28px", // TODO Add uisk density to theme SU-100
      height: "28px",
      color: palette["text-quaternary"],

      "&:hover": {
        backgroundColor: palette["bg-primary_hover"],
      },
      "&.Mui-selected, &.Mui-selected:hover": {
        color: palette["text-quaternary_on-brand"],
        backgroundColor: palette["bg-secondary_subtle"],
        borderTop: `1px solid ${palette["border-brand"]}`,
      },
    }),
  },
}
